"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
function SpeedIcon(_a) {
    var { fill = 'white' } = _a, props = __rest(_a, ["fill"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "20", height: "12", viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("path", { fill: fill, fillRule: "evenodd", clipRule: "evenodd", d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10V11C20 11.5523 19.5523 12 19 12C18.4477 12 18 11.5523 18 11V10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10V11C2 11.5523 1.55228 12 1 12C0.447715 12 0 11.5523 0 11V10ZM13.6 5.2C14.0418 5.53137 14.1314 6.15817 13.8 6.6L11.8396 9.21389C11.9428 9.45519 12 9.72092 12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C10.081 8 10.1609 8.00482 10.2394 8.01418L12.2 5.4C12.5314 4.95817 13.1582 4.86863 13.6 5.2Z" })));
}
exports.default = SpeedIcon;
